import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';
import { UserProfileComponent } from 'src/app/components/user/user-profile.component';
import { DashboardComponent } from 'src/app/components/dashboard/regular-dashboard/dashboard.component';
import { TicketFormComponent } from './form/ticket-form.component';
import { TicketMessagerComponent } from './messages/ticket-messager.component';

export const routes: Route[] = [
    {
        path: '',
        redirectTo: 'new',
        pathMatch: 'full'
    },
    {
        path: 'new',
        component: TicketFormComponent,
        data: { pageTitle: 'NEW' }
    },
    {
        path: 'messages',
        component: TicketMessagerComponent,
        data: { pageTitle: 'MESSAGES' }
    }
]

@NgModule({
    declarations: [],
    imports: [ RouterModule.forChild(routes) ],
    exports: [ RouterModule ],
    providers: [],
})
export class SupportRequestRoutingModule {}